export default __webpack_public_path__ + "static/media/kali.0ccb6d9a.png";